var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMiniAlbercaResting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "txnxa13sca",
    width: 25,
    height: 25,
    x: 7,
    y: 8,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M7.568 8.648H31.35v23.374H7.568V8.648z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#txnxa13sca)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M16.999 19.087h4.921v-2.879h-4.921v2.88zm2.454 3.579c-1.089 0-1.853.29-2.453.65v-2.067h4.92v2.075c-.602-.365-1.37-.659-2.467-.659zM8.649 24.828c.972 0 1.39.336 2.025.844.734.587 1.646 1.318 3.375 1.318 1.73 0 2.644-.731 3.378-1.318.635-.508 1.055-.844 2.026-.844.974 0 1.417.354 2.03.844.734.587 1.649 1.318 3.379 1.318 1.732 0 2.645-.731 3.38-1.318.636-.508 1.056-.844 2.028-.844.598 0 1.081-.485 1.081-1.081 0-.597-.483-1.081-1.08-1.081-1.732 0-2.645.73-3.38 1.317-.612.491-1.055.845-2.03.845-.318 0-.566-.047-.793-.114.002-.025.014-.046.014-.072V11.78c0-.432.351-.783.783-.783.431 0 .784.35.784.783 0 .597.483 1.081 1.08 1.081.598 0 1.082-.484 1.082-1.08 0-1.625-1.322-2.946-2.946-2.946s-2.945 1.321-2.945 2.945v2.266H17v-2.452c0-.432.35-.784.782-.784.432 0 .783.352.783.784 0 .597.484 1.081 1.081 1.081.598 0 1.082-.484 1.082-1.08 0-1.625-1.323-2.947-2.946-2.947-1.624 0-2.944 1.322-2.944 2.946v12.86c0 .087.029.164.05.245-.238.076-.499.129-.84.129-.97 0-1.389-.335-2.023-.844-.734-.588-1.646-1.319-3.376-1.319-.598 0-1.081.485-1.081 1.082 0 .596.483 1.08 1.08 1.08zM30.27 27.698c-1.73 0-2.644.73-3.378 1.318-.613.49-1.057.844-2.03.844-.972 0-1.393-.336-2.028-.844-.735-.587-1.649-1.318-3.38-1.318-1.73 0-2.644.73-3.378 1.318-.636.508-1.054.844-2.027.844-.97 0-1.39-.336-2.024-.843-.734-.588-1.645-1.32-3.376-1.32-.598 0-1.081.485-1.081 1.082 0 .597.483 1.081 1.08 1.081.972 0 1.391.336 2.026.844.734.587 1.646 1.318 3.375 1.318 1.73 0 2.644-.73 3.378-1.318.635-.508 1.055-.844 2.026-.844.974 0 1.417.355 2.03.844.734.587 1.648 1.318 3.379 1.318 1.732 0 2.645-.73 3.38-1.318.636-.508 1.056-.844 2.028-.844.598 0 1.082-.484 1.082-1.081s-.484-1.081-1.082-1.081z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMiniAlbercaResting);
export default __webpack_public_path__ + "static/media/icon_mini_alberca_resting.6d870689ef278b5f8dc9f7a93080ad33.svg";
export { ForwardRef as ReactComponent };